/**
 * Loading polyfill JS if needed
 *
 * https://caniuse.com/#search=srcset
 * e.g. IE11 needs to load polyfill for displaying responsive Images
 *
 * Feature Detects SRCSET and SIZES and loads picturefill if needed:
 * https://scottjehl.github.io/picturefill/
 *
 */

function polyfillImages() {
    // create an image node so we can test its properties
    var img = document.createElement('img');
    // feature detect
    var supportSrcset = ('srcset' in img) && ('sizes' in img);
    if (!supportSrcset) {
        // feature not available:
        // create a script tag
        var script = document.createElement('script');
        script.src = '/wp-content/themes/architektur/js/picturefill.min.js';
        script.setAttribute('async', '')
        // add it to the document <head>...
        var head = document.getElementsByTagName('head')[0];
        head.appendChild(script);
    }
}

// call the method
polyfillImages();
